import { render, staticRenderFns } from "./mobile-quick-link-wrapper.vue?vue&type=template&id=6d48c125&lang=pug&"
import script from "./mobile-quick-link-wrapper.vue?vue&type=script&lang=js&"
export * from "./mobile-quick-link-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports